import * as React from "react";
import cn from "classnames";
import DatePicker, { registerLocale } from "react-datepicker";
import { format } from "date-fns";
import ru from 'date-fns/locale/ru';

import { FieldWrapper } from "components/FieldWrapper";

import styles from "../TextField/TextField.module.scss";
import { FieldWrapperProps } from "components/FieldWrapper/FieldWrapper";
import "react-datepicker/dist/react-datepicker.css";

registerLocale('ru', ru)

export interface DatePickerProps extends React.HTMLProps<HTMLInputElement> {
  value: string;
  icon?: React.ReactNode;
  inputSize?: "small" | "medium";
  onchange: (date: string) => void;
}

const AppDatePicker = React.forwardRef<
  HTMLInputElement,
  DatePickerProps & FieldWrapperProps
>(
  (
    { label, icon, value, inputSize = "medium", error, withError, required, onchange, ...props },
    ref
  ) => {
    const inputSizeStyle = {
      small: styles.inputSmall,
      medium: styles.inputMedium,
    };

    function _onChange(rawValue: Date | null) {
      const date = rawValue
        ? format(new Date(rawValue), "yyyy-MM-dd")
        : "";
      onchange(date)
    }

    return (
      <FieldWrapper
        error={error}
        withError={withError}
        label={label}
        required={required}
      >
        <div
          className={cn(
            styles.inputContainer,
            icon ? styles.inputContainer__icon : null
          )}
        >
          <DatePicker
            locale="ru"
            selected={value ? new Date(value) : null}
            placeholderText="дд.мм.гггг"
            dateFormat="dd/MM/yyyy"
            className={cn(styles.input, inputSizeStyle[inputSize])}
            onChange={_onChange}
          />
        </div>
      </FieldWrapper>
    );
  }
);

export default AppDatePicker